<template>

  <auto-complete-master-data-select
          display-type="idOnly"
          :label="label"
          :prepared-options="getDriverGroupOptionsForUser"
          :init-value-id="value"
          :watch-value-id="selectedValue"
          :on-item-changed="handleDriverGroupSelected">
  </auto-complete-master-data-select>

</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      label: String,
      value: String,
    },
    data: () => ({
      selectedValue: null,
    }),
    computed: {
      ...mapGetters([
        'getDriverGroupOptionsForUser',
        'getMasterDataName',
      ]),
    },
    watch: {
      value(val) {
        console.log("val=",val);
        this.selectedValue = val;
      },
      selectedValue(val) {
        this.$emit('input', val);
      },
    },
    mounted() {
      this.$nextTick(() => {
        if (this.value) {
          this.selectedValue = this.value;
        }
      });
    },
    methods: {
      handleDriverGroupSelected(id) {
        this.selectedValue = id;
      },
    },
  }

</script>
